<template>
  <v-autocomplete
    v-model="entity"
    :items="listaAllAffiliates"
    v-on:keyup="searchAutoComplete"
    :search-input.sync="searchText"
    :loading="isLoadingAutoComplete"
    :disabled="disabled"
    :error-messages="errorMessages"
    item-text="name"
    item-value="id"
    :outlined="isOutlined"
    :dense="isDense"
    :hide-details="hideDetails"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import { difference } from 'lodash'

import { errorSnackbar } from '@/core/service/utils'

export default {
  name: 'LancamentoCaixaAutoComplete',
  // props: ['typesEntities', 'inativos'],
  props: {
    entityProps: {
      type: String || Number,
      default: ''
    },
    typesEntities: {
      type: Array,
      default: () => []
    },
    inativos: {
      type: Boolean,
      default: null
    },

    label: {
      type: String,
      default: 'Terminal'
    },

    stop: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    errorMessages: {
      type: Array,
      default: () => []
    },

    treeProps: {
      type: Boolean,
      default: false
    },

    isDense: {
      type: Boolean,
      default: true
    },

    isOutlined: {
      type: Boolean,
      default: false
    },

    hideDetails: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoadingAutoComplete: false,
    modelAutoComplete: null,
    searchText: null,
    loading: false,
    entity: null,
    listEntitiesSelect: [],
    debounce: ''
  }),

  mounted () {
    if (!this.stop) {
      this.getAffiliates(this.entityProps ? parseInt(this.entityProps) : '')
    }
    this.entity = this.entityProps
  },

  watch: {
    entity (val) {
      this.setParentIdAffiliate(val)
    },

    entityProps (val) {
      this.entity = val
    },
  },

  computed: {
    ...mapGetters('afiliadosPendentes', ['listaAllAffiliates', 'getParentIdAffiliate', 'parentIdAffiliate']),
  },

  methods: {
    ...mapActions('afiliadosPendentes', ['obterTodosAfiliados', 'setParentIdAffiliate']),
    searchAutoComplete(event) {
      switch (event.keyCode) {
        case 37: // Left 
        case 38: // Up 
        case 39: // Right 
        case 40: // Down 
        case 13: // Enter 
        case 17: // Ctrl 
        case 18: // Alt 
        case 92: // Meta 
          return
      }

      

      clearTimeout(this.debounce)
      const vm = this
      this.debounce = setTimeout(() => {
        if (vm.searchText === null || vm.searchText.length === 0) {
          vm.pesquisar('')
          return
        }

        vm.pesquisar(vm.searchText)
      }, 600)
    },

    pesquisar (val) {
      this.isLoadingAutoComplete = true
      this.getAffiliates(val)
        .catch(err => {
          errorSnackbar(err.error)
        })
        .finally(() => this.isLoadingAutoComplete = false)
    },

    async getAffiliates (filter) {
      let filterId
      if (filter && typeof filter === 'number') {
        filterId = filter
      }
      this.isLoadingAutoComplete = true
      
      return await this.obterTodosAfiliados({
          _filter: filter,
          pageSize: this.$store.getters.ItensPaginacao,
          filterId
      }).then(e => {
        this.listEntitiesSelect = e
      })
      .finally(() => this.isLoadingAutoComplete = false)
    }
  }
}
</script>